// removed by extract-text-webpack-plugin
module.exports = {"flexColumn":"flexColumn__zgUKW","flexRow":"flexRow__10njs","splitInputErrorText":"splitInputErrorText__3VMTc","inputErrorText":"inputErrorText__1TNe0"};


//////////////////
// WEBPACK FOOTER
// ./components/checkoutWidget/style.css
// module id = FUfM
// module chunks = 459